module.exports = __webpack_public_path__ + "img/umbrella.62b01f45.jpg";